import { RGCompetencyModel, RGDomainModel, RGTopicModel } from '@/models/proficiency/route-generator';
import { sortByProperty } from '@/utils/utils';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'route-generate-panel',
})

export default class RouteGeneratePanel extends Vue {

// -------------------------------------------------------------------------------
// Properties

    @Prop()
    private rgDomains!: RGDomainModel[];

    @Prop({default: null})
    private competency: any;


    @Prop({default: null})
    private topic: any;

    private get competencyList() {
        const competencyList: RGCompetencyModel[] = [...this.rgDomains]
                .map((item) => item.topics.map((topic) => topic.competency)).flat(2);
        sortByProperty(competencyList, 'competencySeq', 'ASC');
        return competencyList;
    }

// ----------------------------------------------------------------------
// Actions

    private onCloseRoute() {
        this.$emit('onCloseRoute');
    }


}
